import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import AnchorButton from '../common/AnchorButton.js';
import COLOR from '../../foundation/color.js';
import styles from './SolidTab.module.scss.js';

var _excluded = ["icon", "tabName", "active"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var SolidTabItem = function SolidTabItem(_ref) {
  var icon = _ref.icon,
    tabName = _ref.tabName,
    active = _ref.active,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", {
    className: cx('item')
  }, /*#__PURE__*/React.createElement(AnchorButton, _objectSpread({
    className: cx('link', {
      'is-selected': active
    })
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    className: cx('icon')
  }, icon), tabName && /*#__PURE__*/React.createElement("span", null, tabName), active && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD604\uC7AC \uC704\uCE58")));
};
function SolidTab(_ref2) {
  var typeLayout = _ref2.typeLayout,
    type = _ref2.type,
    tabWidth = _ref2.tabWidth,
    _ref2$tabMaxWidth = _ref2.tabMaxWidth,
    tabMaxWidth = _ref2$tabMaxWidth === void 0 ? '335px' : _ref2$tabMaxWidth,
    _ref2$colorSet = _ref2.colorSet,
    colorSet = _ref2$colorSet === void 0 ? COLOR.gray100.name : _ref2$colorSet,
    items = _ref2.items,
    selectedKey = _ref2.selectedKey,
    selectedIndex = _ref2.selectedIndex;
  var isSolidTabFixed = typeLayout === 'fixed';
  var isLargeWidth = isSolidTabFixed && items.length > 2;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('article', "colorset-".concat(colorSet), type, typeLayout, {
      'width-large': isLargeWidth
    }),
    style: {
      width: tabWidth,
      maxWidth: isLargeWidth ? tabMaxWidth : undefined
    }
  }, _mapInstanceProperty(items).call(items, function (item, index) {
    var _item$key;
    var key = (_item$key = item.key) !== null && _item$key !== void 0 ? _item$key : index;
    return /*#__PURE__*/React.createElement(SolidTabItem, _objectSpread(_objectSpread({}, item), {}, {
      key: key,
      active: selectedIndex === index || selectedKey === key
    }));
  }));
}

export { SolidTab as default };
